module.exports = __webpack_public_path__ + "img/insuranceline.e5aeb8af.jpg";